package com.milta.core.localization.translations.it

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Annulla",
    confirm = "Conferma",
    save = "Salva",
    delete = "Elimina",
    back = "Indietro",
    loading = "Caricamento…",
    retry = "Riprova",
    language = "Lingua",
    welcomeTitle = "Benvenuto su Milta",
    welcomeSubtitle = "Il tuo assistente intelligente per le consegne",
    alreadyHaveAccount = "Ho già un account",
    createAccount = "Crea un account",
    continueWithGoogle = "Continua con Google",
    continueWithApple = "Continua con Apple",
    oauthErrorGeneric = "Si è verificato un errore durante l'accesso. Riprova.",
    oauthAppleWebComingSoon = "L'accesso con Apple sarà presto disponibile sul web.",
    oauthDriverAccountNotAllowedOnWeb = "Gli account autista non possono accedere alla dashboard web. Accedi tramite l'app mobile.",
    oauthAccountNotFoundOnWeb = "Nessun account Milta trovato per questo account Google.",
    errorOffline = "Nessuna connessione internet.",
    navTourneesDuJour = "Giri di oggi",
    navAjouterUneTournee = "Aggiungi un giro",
    navHistoriqueDesPreuves = "Storico consegne",
    navParametres = "Impostazioni",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Nessuna consegna",
    noDeliveriesYetSubtitle = "Tocca «Aggiungi consegne» per aggiungerne",
    optimizationUnavailableExplanation = "Vuoi creare il giro senza ottimizzazione, oppure riprovare?",
    createWithoutOptimizationAction = "Crea senza ottimizzazione",
    gpsAppSheetTitle = "Scegli un'app di navigazione",
    addressSearchingLabel = "Ricerca in corso…",
)
